import React, { useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { UiTextField, UiIcon } from 'ui-components';
import { useOnClickOutside, useRouter } from 'hooks';
import { getCurrentSlice } from 'utils';
import { COUNTRIES } from './countries';
import { CountryFilterDropdown, CountryFilterSelectedList } from './components';
import { StyledCountryFilter } from './CountryFilter.styles';

const countryFilterDefault = {};

export function CountryFilter(props) {
  const { componentName, parentPlatform, className } = props;
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { clearRouterFilters } = useRouter();
  const [searchValue, setSearchValue] = useState('');
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);
  const ref = useRef(null);

  const filter =
    useSelector((state) =>
      parentPlatform
        ? state?.[state?.filterReducer?.filtersContext]?.filters?.[
            parentPlatform
          ]?.[componentName]
        : state?.[state?.filterReducer?.filtersContext]?.filters?.[
            componentName
          ]
    ) || countryFilterDefault;

  const reducerName = useSelector(
    (state) => state.filterReducer.filtersContext
  );
  const { selectedIds = [] } = filter;
  const { setSelectedFilterIds } = getCurrentSlice(reducerName);

  useOnClickOutside(ref, () => setIsDropdownVisible(false));

  const handleSelect = (id) => {
    dispatch(
      setSelectedFilterIds({
        id,
        isChecked: true,
        componentName,
        parentPlatform,
      })
    );
    setIsDropdownVisible(false);
    setSearchValue('');
    clearRouterFilters();
  };

  const handleRemove = (id) => {
    dispatch(
      setSelectedFilterIds({
        id,
        isChecked: false,
        componentName,
        parentPlatform,
      })
    );
    clearRouterFilters();
  };

  return (
    <StyledCountryFilter>
      <div className={classNames('filter-country', className)} ref={ref}>
        <UiTextField
          value={searchValue}
          onChange={(e) => setSearchValue(e.target.value)}
          onClick={() => setIsDropdownVisible(true)}
          placeholder={t('filter:searchCountry')}
          InputProps={{
            startAdornment: (
              <UiIcon icon='ri-search-line' className='search-icon' />
            ),
          }}
        />
        {isDropdownVisible && (
          <CountryFilterDropdown
            searchValue={searchValue}
            countries={COUNTRIES}
            selectedIds={selectedIds}
            onSelect={handleSelect}
          />
        )}
        {selectedIds.length > 0 && (
          <CountryFilterSelectedList
            countries={COUNTRIES}
            selectedIds={selectedIds}
            onRemove={handleRemove}
          />
        )}
      </div>
    </StyledCountryFilter>
  );
}

CountryFilter.propTypes = {
  componentName: PropTypes.string.isRequired,
  parentPlatform: PropTypes.string,
  className: PropTypes.string,
};
